<template>
  <router-view />
</template>
<script>
export default {
  name: "App",
  watch: {
    // async $route(val) {
    //   if (val.path !== "/login") {
    //     await this.$store.dispatch("user/getInfo");
    //   }
    // },
  },
};
</script>
<style lang="less" scoped>
</style>